exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reading-time[data-v-401adf7c]:before{content:\"\\2022   \";margin-left:.5rem;margin-right:.5rem}", ""]);

// exports
